export const FIELD_NAME = 'portalAlerts';
export const BY_DATE = 1676894400000;
export const DISPLAY_UNTIL = 1677672000000;
export const INVALID_NOTIFICATION_RECIPIENTS = 'INVALID_NOTIFICATION_RECIPIENTS';